import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useCreateWebsiteProductMutation } from "../../../features/api/websiteApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const CreateProduct = () => {
  const navigate = useNavigate();

  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [title, setTitle] = useState("");
  const [shortDesc, setShortDesc] = useState("");
  const [longDesc, setLongDesc] = useState("");
  const [status, setStatus] = useState("1");

  const [createWebsiteProduct, { isLoading }] =
    useCreateWebsiteProductMutation();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim()) {
      toast.error("Title is required");
      return;
    }

    try {
      const formData = new FormData();
      if (image) formData.append("image", image);
      formData.append("title", title);
      formData.append("short_desc", shortDesc);
      formData.append("long_desc", longDesc);
      formData.append("status", status);

      await createWebsiteProduct(formData).unwrap();

      toast.success("Product created successfully!");
      navigate("/dashboard/website/products");

      setImage(null);
      setImagePreview(null);
      setTitle("");
      setShortDesc("");
      setLongDesc("");
      setStatus("1");
    } catch (err) {
      toast.error(err?.data?.message || "Failed to create product");
    }
  };

  return (
    <div className="px-12 my-6">
      <h2 className="text-2xl font-bold mb-4">Create Product</h2>
      <form
        onSubmit={handleSubmit}
        className=" mx-auto p-6 bg-white rounded shadow-md space-y-6"
      >
        <div className="flex items-center gap-5">
          <div className="w-full">
            <label className="block mb-1 font-medium">Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Product title"
              required
            />
          </div>
          <div className="w-52">
            <label className="block mb-1 font-medium">Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>
        </div>

        <div>
          <label className="block mb-1 font-medium">Short Description</label>
          <textarea
            value={shortDesc}
            onChange={(e) => setShortDesc(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
            rows={3}
            placeholder="Short description"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Product Details</label>
          <div>
            <ReactQuill
              theme="snow"
              value={longDesc}
              onChange={setLongDesc}
              modules={{
                toolbar: [
                  [{ font: [] }, { size: [] }],
                  ["bold", "italic", "underline", "strike"],
                  [{ color: [] }, { background: [] }],
                  [{ script: "sub" }, { script: "super" }],
                  [{ header: [1, 2, 3, 4, 5, 6, false] }],
                  [{ align: [] }],
                  ["blockquote", "code-block"],
                  [
                    { list: "ordered" },
                    { list: "bullet" },
                    { indent: "-1" },
                    { indent: "+1" },
                  ],
                  ["direction", "link", "image", "video", "formula"],
                  ["clean"],
                ],
              }}
              formats={[
                "font",
                "size",
                "bold",
                "italic",
                "underline",
                "strike",
                "color",
                "background",
                "script",
                "header",
                "align",
                "blockquote",
                "code-block",
                "list",
                "bullet",
                "indent",
                "direction",
                "link",
                "image",
                "video",
                "formula",
                "clean",
              ]}
              placeholder="Enter detailed description"
            />
          </div>
        </div>

        <div>
          <label className="block mb-1 font-medium">Image</label>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {imagePreview && (
            <img
              src={imagePreview}
              alt="Preview"
              className="mt-3 w-40 h-40 object-cover rounded border border-gray-300"
            />
          )}
        </div>

        <div className="flex justify-end">
          {" "}
          <button
            type="submit"
            disabled={isLoading}
            className={`w-32 py-2 rounded text-white font-semibold ${
              isLoading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            {isLoading ? "Creating..." : "Create Product"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateProduct;
